<div class="dialog">
    <button class="close-button" type="button"
        (click)="close()" [attr.aria-label]="closeAriaLabel()">
        <span class="material-symbols-outlined">close</span>
    </button>
    <div class="dialog-content">
        <h2 class="modal-title">{{ modalTitle() }}</h2>
        @if (submitError() || submitIssues().length) {
            <div class="alert alert-danger" role="alert">
                @if (submitError()) {
                    <div>{{ submitError() }}</div>
                }

                @if (submitIssues().length) {
                    <ul>
                        @for (issue of submitIssues(); track $index) {
                            <li>
                                @if (issue.property) {
                                    <strong>{{ issue.property }}</strong>: {{ issue.message }}
                                } @else {
                                    {{ issue.message }}
                                }
                            </li>
                        }
                    </ul>
                }
            </div>
        }
        <mat-stepper #stepper [linear]="false" class="stepper stepper--noheader"
            (selectionChange)="onStepperSelectionChange($event)">
            <mat-step [stepControl]="step1" label="Details">
                <form [formGroup]="step1" class="step step--details">
                    <div class="step-grid step-grid--details">
                        <div class="field field--name">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>tool name</mat-label>
                                <input matInput required type="text" formControlName="name"
                                placeholder="enter tool name" autocomplete="off"/>
                                @if ( step1.controls.name.touched && step1.controls.name.hasError("required") ) 
                                {
                                    <mat-error>tool name is required.</mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div class="field field--url">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>link</mat-label>
                                <input matInput required type="text" formControlName="url"
                                    placeholder="https:// or companyportal:ApplicationId="/>
                                @if ( step1.controls.url.touched && step1.controls.url.hasError("required")) {
                                    <mat-error>link is required.</mat-error>
                                }
                                @if ( step1.controls.url.touched && step1.controls.url.hasError("url")) 
                                {
                                    <mat-error>Enter a valid http(s) URL or companyportal:ApplicationId=...</mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div class="field field--short">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>short description</mat-label>
                                <textarea matInput rows="4" formControlName="shortDescription"
                                    maxlength="300" placeholder="300 character limit">
                                </textarea>
                                <mat-hint align="end">{{ shortDescriptionCount() }}/300</mat-hint>
                            </mat-form-field>
                        </div>

                        <div class="field field--preview">
                            <app-image-selector #previewImageSelector mode="single"
                                formControlName="previewImage"
                                [sessionKey]="uploadSessionKey"
                                [buttonLabel]="'Select Preview Image'"
                                (referenceChange)="previewReference.set($event)"
                                (uploadingChange)="isUploadingPreview.set($event)"/>
                        </div>

                        <div class="field field--launch">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>launch type</mat-label>
                                <mat-select formControlName="launchType"
                                    required placeholder="Select Launch Type">
                                    @for (opt of launchTypeOptions;track opt.value) 
                                    {
                                        <mat-option [value]="opt.value">{{opt.label}}</mat-option>
                                    }
                                </mat-select>
                                @if (step1.controls.launchType.touched && step1.controls.launchType.hasError('required')) 
                                {
                                    <mat-error>Launch type is required.</mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div class="field field--service">
                            <div class="service-line">
                                <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label>service id</mat-label>
                                    <input matInput type="text" formControlName="serviceId"
                                        autocomplete="off" placeholder="enter service id"
                                        [matAutocomplete]="serviceIdAuto"
                                        (blur)="onServiceIdBlur()"
                                        (keydown.enter)="onServiceIdEnter($event)"/>

                                    <mat-autocomplete #serviceIdAuto="matAutocomplete"
                                        (optionSelected)="onServiceIdSelected($event.option.value)">
                                        @if (cmdbContactsLoading()) {
                                            <mat-option disabled>Searching...</mat-option>
                                        }
                                        @for (opt of serviceIdSuggestions(); track opt.trackKey) {
                                            <mat-option [value]="opt">{{ opt.label }}</mat-option>
                                        }
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="field field--status">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>status</mat-label>
                                <mat-select formControlName="status">
                                    @for (s of toolStatusOptions; track s) {
                                        <mat-option [value]="s">{{ s }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="field field--desc1">
                            <div class="rich-field">
                                <div class="field-label">description</div>
                                <p-editor formControlName="description" styleClass="rich-editor" placeholder="Enter description...">
                                    <ng-template pTemplate="header">
                                        <span class="ql-formats">
                                            <button type="button" class="ql-bold" aria-label="Bold"></button>
                                            <button type="button" class="ql-italic" aria-label="Italic"></button>
                                            <button type="button" class="ql-underline" aria-label="Underline"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button type="button" class="ql-list" value="ordered" aria-label="Ordered list"></button>
                                            <button type="button" class="ql-list" value="bullet" aria-label="Bullet list"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button type="button" class="ql-link" aria-label="Insert link"></button>
                                            <button type="button" class="ql-clean" aria-label="Clear formatting"></button>
                                        </span>
                                    </ng-template>
                                </p-editor>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="step2" label="Modal">
                <form [formGroup]="step2" class="step step--modal">
                    <div class="step-grid step-grid--modal">
                        <div class="field field--personas">
                            <multi-select-chip-field label="personas" placeholder="Select personas"
                                selectId="personas" [options]="personaOptions()" formControlName="personaIds"/>
                        </div>

                        <div class="field field--lifecycle">
                            <multi-select-chip-field label="lifecycle phases" placeholder="Select lifecycle phases"
                                selectId="lifecycle" [options]="lifecycleOptions()" formControlName="lifeCyclePhaseIds"/>
                        </div>

                        <div class="field field--types">
                            <multi-select-chip-field label="tool types" placeholder="Select tool types"
                                selectId="toolTypes" [options]="toolTypeOptions()" formControlName="toolTypeIds"/>
                        </div>

                        <div class="field field--special">
                            <div class="rich-field">
                                <div class="field-label">special conditions</div>
                                <p-editor formControlName="specialCondition" styleClass="rich-editor" placeholder="Enter special conditions..." >
                                    <ng-template pTemplate="header">
                                        <span class="ql-formats">
                                            <button type="button" class="ql-bold" aria-label="Bold"></button>
                                            <button type="button" class="ql-italic" aria-label="Italic"></button>
                                            <button type="button" class="ql-underline" aria-label="Underline"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button type="button" class="ql-list" value="ordered" aria-label="Ordered list"></button>
                                            <button type="button" class="ql-list" value="bullet" aria-label="Bullet list"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button type="button" class="ql-link" aria-label="Insert link"></button>
                                            <button type="button" class="ql-clean" aria-label="Clear formatting"></button>
                                        </span>
                                    </ng-template>
                                </p-editor>
                            </div>
                        </div>

                        <div class="field field--gallery">
                            <app-image-selector #galleryImageSelector  mode="multiple" formControlName="galleryImages"
                                [sessionKey]="uploadSessionKey" [buttonLabel]="'Add Gallery Images'" [maxImages]="10"
                                (uploadingCountChange)="uploadingGalleryCount.set($event)"/>
                        </div>
                    </div>

                    <span #chipMeasure class="chip chip--measure"></span>
                    <span #moreMeasure class="chip chip--more chip--measure"></span>
                </form>
            </mat-step>

            <mat-step [stepControl]="step3" label="Additional">
                <form [formGroup]="step3" class="step step--additional">
                    <documentation-links-table [documentationLinks]="documentationLinks"/>
                    <hr>
                    <alternative-tools-table [alternativeTools]="alternativeTools" [toolOptions]="toolOptions()"
                        [toolOptionsLoading]="toolOptionsLoading()" [toolOptionsError]="toolOptionsError()"/>
                    <hr>
                    <contacts-table #contactsTable [contacts]="contacts" [isLoading]="cmdbContactsLoading()" />
                </form>
            </mat-step>
        </mat-stepper>
        
        <form-footer #formFooter [stepConfigs]="stepConfigs()" [submitState]="submitState()"
            [submitTooltip]="submitDisabledTooltip()" (stepChange)="onStepChange($event)" 
            (cancelClicked)="close()" (submitClicked)="submit()"/>
    </div>
</div>
